import i18next from "i18next";
import { call, put, takeLatest } from "redux-saga/effects";
import { deleteTermin } from "../../../api/terminApi";
import { createErrorNotification, createInfoNotification } from "../../../models/notification";
import { emitNotificationAction } from "../../notification/notificationAction";
import { DELETE_TERMIN } from "../terminActions";

function* processDeleteTermin({payload}) {
    try {
        yield call(deleteTermin, {terminId: payload.terminId})
        yield put(emitNotificationAction(createInfoNotification(i18next.t('TERMIN.DELETE_TERMIN_SUCCESS_INFO'), 'processDeleteTermin')))
    } catch (err) {
        if (err.response?.status === 404) {
            yield put(emitNotificationAction(createInfoNotification(i18next.t('TERMIN.DELETE_TERMIN_SUCCESS_INFO'), 'processDeleteTermin')))
        } else {
            yield put(emitNotificationAction(createErrorNotification(i18next.t('TERMIN.DELETE_DATA_FAILED_INFO'), 'processDeleteTermin')))
            console.log(err)
        }
    }
}

export function* watchDeleteTermin() {
    yield takeLatest(DELETE_TERMIN, processDeleteTermin)
}